import { flowApi } from '.';
import { TAG_TYPES } from 'types/services';
import type {
  GetViewFormItemsFilterRes,
  GetViewFormItemsReq,
  GetViewFormItemsRes,
  GetViewSettingsReq,
  GetViewSettingsRes,
  UpdateViewFormItemsReq,
  UpdateViewFormItemsRes,
  UpdateViewSettingsReq,
} from 'types';

export const viewFormItemsService = flowApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getViewFormItems: builder.query<GetViewFormItemsRes, GetViewFormItemsReq>({
      query: ({ viewId }) => ({
        url: `Views/${viewId}/FormItems`,
        method: 'GET',
      }),
      providesTags: [
        {
          type: TAG_TYPES.VIEWS,
          id: 'LIST',
        },
      ],
    }),
    getFilterViewFormItems: builder.query<GetViewFormItemsFilterRes, GetViewFormItemsReq>({
      query: ({ viewId, levels }) => ({
        url: `Views/${viewId}/FormItems/Filter`,
        method: 'GET',
        params: { levels },
      }),
    }),
    getViewWidgetSettings: builder.query<GetViewSettingsRes, GetViewSettingsReq>({
      query: ({ viewWidgetId }) => ({
        url: `Views/Widgets/${viewWidgetId}`,
        method: 'GET',
      }),
    }),
    updateViewWidgetSettings: builder.mutation<GetViewFormItemsFilterRes, UpdateViewSettingsReq>({
      query: ({ viewWidgetId, body }) => ({
        url: `Views/Widgets/${viewWidgetId}`,
        method: 'PUT',
        body,
      }),
    }),
    // Currently unused
    updateViewFormItems: builder.mutation<UpdateViewFormItemsRes, UpdateViewFormItemsReq>({
      query: ({ viewId, body }) => ({
        url: `Views/${viewId}/FormItems`,
        method: 'PUT',
        body,
      }),
    }),
    // Currently unused
    getUsableViewFormItems: builder.query<GetViewFormItemsRes, GetViewFormItemsReq>({
      query: ({ viewId }) => ({
        url: `Views/${viewId}/FormItems/Usable`,
        method: 'GET',
      }),
    }),
  }),
});
export const {
  useGetViewFormItemsQuery,
  useLazyGetViewFormItemsQuery,
  useUpdateViewFormItemsMutation,
  useGetFilterViewFormItemsQuery,
  useGetUsableViewFormItemsQuery,
  useLazyGetFilterViewFormItemsQuery,
  useLazyGetUsableViewFormItemsQuery,
  useGetViewWidgetSettingsQuery,
  useUpdateViewWidgetSettingsMutation,
} = viewFormItemsService;
